import request from '../../axios';

export interface IPostTerminateAgreement {
  guid: string;
  termination_reason: string;
}
export const postTerminateAgreement = async (
  payload: IPostTerminateAgreement,
) => {
  await request.post(`/api/v2/store/cooperation-agreement-termination`, {
    ...payload,
  });
};
